import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataTableRequest } from 'src/app/models/datatable-request';
import { GeneralResponse } from 'src/app/models/general-response';
import { environment } from 'src/environments/environment';
import { CommonConfig } from '../../constants/common-config';
import { PaginatedCuti } from '../../models/paginated-cuti.t';
import { Cuti } from '../../models/cuti.t';
import { ApprovalRequest } from '../../models/approval-request.t';
import { Dashboard } from '../../models/dashboard.t';

@Injectable({
  providedIn: 'root'
})
export class CutiService {
  readonly path = '/cuti';

  constructor(private http: HttpClient) { }

  getDatas(payload: DataTableRequest): Observable<PaginatedCuti> {
    return this.http.get<PaginatedCuti>(`${environment.apiUrl}${this.path}/list/${payload.userId}/${payload.page}/${payload.dataPerPage}`,
      {
        ...CommonConfig.HTTP_OPTIONS,
      }
    );
  }

  getApprovalDatas(payload: DataTableRequest, substansiId: number, dateFrom: string, dateTo: string, statusId: number, searchTerm: string): Observable<PaginatedCuti> {
    let params = new HttpParams();
    params = params.append('substansiId', substansiId);
    params = params.append('dateFrom', dateFrom);
    params = params.append('dateTo', dateTo);
    params = params.append('statusId', statusId);
    params = params.append('searchTerm', payload.searchTerm);
    return this.http.get<PaginatedCuti>(`${environment.apiUrl}${this.path}/approval-list/${payload.userId}/${payload.page}/${payload.dataPerPage}`,
      {
        ...CommonConfig.HTTP_OPTIONS,
        params: params,
      }
    );
  }

  count(data: Cuti): Observable<GeneralResponse> {
    return this.http.post(`${environment.apiUrl}${this.path}/count`, data, {
      ...CommonConfig.HTTP_OPTIONS,
    });
  }

  save(data: Cuti): Observable<Cuti> {
    return this.http.post(`${environment.apiUrl}${this.path}/save`, data, {
      ...CommonConfig.HTTP_OPTIONS,
    });
  }

  saveSubmit(data: Cuti): Observable<Cuti> {
    return this.http.post(`${environment.apiUrl}${this.path}/save-submit`, data, {
      ...CommonConfig.HTTP_OPTIONS,
    });
  }

  submit(data: Cuti): Observable<Cuti> {
    return this.http.post(`${environment.apiUrl}${this.path}/submit/${data.id}`, {});
  }

  delete(data: Cuti): Observable<GeneralResponse> {
    return this.http.delete(`${environment.apiUrl}${this.path}/delete/${data.id}`);
  }

  cancel(data: ApprovalRequest) {
    return this.http.post(`${environment.apiUrl}${this.path}/cancel`, data, {
      ...CommonConfig.HTTP_OPTIONS,
    });
  }

  approveAtasan(data: ApprovalRequest) {
    return this.http.post(`${environment.apiUrl}${this.path}/approval-atasan`, data, {
      ...CommonConfig.HTTP_OPTIONS,
    });
  }

  approvePejabat(data: ApprovalRequest) {
    return this.http.post(`${environment.apiUrl}${this.path}/approval-pejabat`, data, {
      ...CommonConfig.HTTP_OPTIONS,
    });
  }

  print(
    ids: String[]
  ): Observable<GeneralResponse> {
    return this.http.post<GeneralResponse>(
      `${environment.apiUrl}${this.path}/print`,
      ids,
      {
        ...CommonConfig.HTTP_OPTIONS,
      }
    );
  }

  saldo(userId: string): Observable<Dashboard> {
    return this.http.get<Dashboard>(`${environment.apiUrl}${this.path}/saldo/${userId}`, {
      ...CommonConfig.HTTP_OPTIONS,
    });
  }
}
